import { select } from 'd3-selection'
import { schemeCategory10 } from 'd3-scale'
import {
  axisLeft,
  axisBottom,
} from 'd3-axis'


const d3 = {
  select,
  schemeCategory10,
  axisBottom,
  axisLeft,
}

export default class Chart {

  constructor(settings, data, id) {

    this.padding = Object.assign({
      top: 20,
      right: 20,
      bottom: 20,
      left: 20
    }, settings.padding)


    this.settings = Object.assign({
      width: 900,
      height: 500,
      colors: d3.schemeCategory10,
      showAxes: true,
      showTickValues: true,
      showTickLines: true,
      showAxisLines: true,
      xAxisPadding: 0,
      yAxisPadding: 0,
      xTickFormat: null,
      yTickFormat: null,
      xTicks: null,
      yTicks: null,
      splitSpaces: false,
      xAxisLabel: null,
      yAxisLabel: null,
      showLegend: false,
    }, settings)

    this.settings.tooltipFormatters = Object.assign({
        mainTitle: (d) => d,
        title: (d) => d,
        value: (d) => d,
      }, settings.tooltipFormatters)

    if(this.settings.colors && this.settings.colors.length) {
      this.setColors(this.settings.colors)
    }

    this.innerHeight = this.settings.height - this.padding.top - this.padding.bottom
    this.innerWidth = this.settings.width - this.padding.left - this.padding.right

    this.data = data
    this.id = id

  }

  drawXAxis(container) {

    if(!this.settings.showAxes) return

    let xAxis = d3.axisBottom(this.xScale)
      .tickFormat(this.settings.xTickFormat)
      .ticks(this.settings.xTicks)

    let axisContainer = container
        .selectAll('g.x-axis').data((d) => [d])

    let axisContainerEnter = axisContainer.enter().append('g')
        .attr('class', 'axis x-axis')

    axisContainer.merge( axisContainerEnter )
      .attr('transform', `translate(${ this.padding.left }, ${ this.padding.top + this.settings.xAxisPadding + this.innerHeight })`)
      .call( xAxis )

    if(!this.settings.showTickValues) {

      container.select('.x-axis')
        .selectAll('.tick').selectAll('text')
        .each(function() {
          d3.select(this).remove()
        })

    }

    if(!this.settings.showTickLines) {

      container.select('.x-axis')
        .selectAll('.tick').selectAll('line')
        .each(function() {
          d3.select(this).remove()
        })

    }

    if(!this.settings.showAxisLines) {

      container.select('.x-axis')
        .selectAll('path')
        .each(function() {
          d3.select(this).remove()
        })

    }

    if(this.settings.xAxisLabel) {
      let axisLabel = container
          .select('.x-axis').selectAll('text.axis-label')
        .data([ this.settings.xAxisLabel ])

      let axisLabelEnter = axisLabel
        .enter().append('text')
          .attr('class', 'axis-label')
          .text((d) => d)
          .attr('y', this.padding.bottom - 12)
          .attr('text-anchor', 'middle')
          .style('fill', '#000')
          .style('font-size', 12)

      axisLabel.merge( axisLabelEnter )
          .attr('x', this.innerWidth/2)

    }

  }

  drawYAxis(container) {

    if(!this.settings.showAxes) return

    let yAxis = d3.axisLeft(this.yScale)
      .tickFormat( this.settings.yTickFormat )
      .ticks( this.settings.yTicks )

    let axisContainer = container
        .selectAll('g.y-axis').data((d) => [d])

    let axisContainerEnter = axisContainer.enter().append('g')
        .attr('class', 'axis y-axis')

    axisContainer.merge( axisContainerEnter )
      .attr('transform', `translate(${ this.padding.left - this.settings.yAxisPadding }, ${ this.padding.top })`)
      .call( yAxis )

    if(!this.settings.showTickValues) {

      container.select('.y-axis')
        .selectAll('.tick').selectAll('text')
        .each(function() {
          d3.select(this).remove()
        })

    }

    if(!this.settings.showTickLines) {

      container.select('.y-axis')
        .selectAll('.tick').selectAll('line')
        .each(function() {
          d3.select(this).remove()
        })

    }

    if(!this.settings.showAxisLines) {

      container.select('.y-axis')
        .selectAll('path')
        .each(function() {
          d3.select(this).remove()
        })

    }

    if(this.settings.splitSpaces) {

      container.selectAll('.y-axis').selectAll('text')
            .text('')
        .selectAll('tspan')
          .data((d) => d.split(' '))
        .enter().append('tspan')
            .text((d) => d)
            .attr('x', -9)
            .attr('y', (d,i) => (-0.5 + i * 1.5) + 'em')
            .attr('text-anchor', 'end')

    }

    if(this.settings.yAxisLabel) {

      let yAxisLabel = container
          .select('.y-axis').selectAll('text.axis-label')
        .data([ this.settings.yAxisLabel ])

      let yAxisLabelEnter = yAxisLabel
        .enter().append('text')
          .attr('class', 'axis-label')
          .text((d) => d)
          .attr('y', -this.settings.padding.left + 25)
          .attr('text-anchor', 'middle')
          .attr('transform', 'rotate(-90)')
          .style('fill', '#000')
          .style('font-size', 12)

      yAxisLabel.merge( yAxisLabelEnter )
          .attr('x', -this.innerHeight/2)
    }

  }

  remove() {
    d3.select('#' + this.id).selectAll('*').remove()
  }

}
